import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "employer-preferences",
  "data-cy": "profile-view-employer-preferences"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = {
  key: 0,
  class: "p-float-label"
}
const _hoisted_4 = { "data-cy": "profile-view-company-size" }
const _hoisted_5 = {
  key: 0,
  class: "tags",
  "data-cy": "profile-view-company-sizes"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "p-no-float-label"
}
const _hoisted_9 = {
  key: 0,
  "data-cy": "profile-edit-company-size-value",
  class: "tags"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "label"
}
const _hoisted_12 = { class: "p-no-float-label" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1)
const _hoisted_15 = {
  key: 1,
  "data-cy": "profile-edit-desiredemployertype",
  class: "tags"
}
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "p-no-float-label" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { "data-cy": "profile-view-client-size" }
const _hoisted_21 = {
  key: 0,
  class: "tags"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 0,
  "data-cy": "profile-edit-client-size-value",
  class: "tags"
}
const _hoisted_26 = { class: "right" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  "data-cy": "profile-view-excluded-companies",
  class: "p-float-label"
}
const _hoisted_29 = {
  key: 0,
  class: "tags"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1)
const _hoisted_32 = { key: 2 }
const _hoisted_33 = {
  "data-cy": "profile-edit-excluded-companies",
  class: "p-float-label"
}
const _hoisted_34 = {
  key: 0,
  class: "tags"
}
const _hoisted_35 = {
  key: 0,
  class: "new-company"
}
const _hoisted_36 = { class: "p-button button-secondary" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "exclude-information p-mt-1" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.2008 9.00005C16.2008 10.9096 15.4422 12.741 14.092 14.0912C12.7417 15.4415 10.9103 16.2 9.00078 16.2C7.09122 16.2 5.25987 15.4415 3.90961 14.0912C2.55935 12.741 1.80078 10.9096 1.80078 9.00005C1.80078 7.09049 2.55935 5.25914 3.90961 3.90888C5.25987 2.55862 7.09122 1.80005 9.00078 1.80005C10.9103 1.80005 12.7417 2.55862 14.092 3.90888C15.4422 5.25914 16.2008 7.09049 16.2008 9.00005V9.00005ZM9.90078 5.40005C9.90078 5.63874 9.80596 5.86766 9.63718 6.03644C9.46839 6.20523 9.23948 6.30005 9.00078 6.30005C8.76209 6.30005 8.53317 6.20523 8.36439 6.03644C8.1956 5.86766 8.10078 5.63874 8.10078 5.40005C8.10078 5.16135 8.1956 4.93244 8.36439 4.76365C8.53317 4.59487 8.76209 4.50005 9.00078 4.50005C9.23948 4.50005 9.46839 4.59487 9.63718 4.76365C9.80596 4.93244 9.90078 5.16135 9.90078 5.40005ZM8.10078 8.10005C7.86209 8.10005 7.63317 8.19487 7.46439 8.36365C7.2956 8.53244 7.20078 8.76135 7.20078 9.00005C7.20078 9.23874 7.2956 9.46766 7.46439 9.63645C7.63317 9.80523 7.86209 9.90005 8.10078 9.90005V12.6C8.10078 12.8387 8.1956 13.0677 8.36439 13.2364C8.53317 13.4052 8.76209 13.5 9.00078 13.5H9.90078C10.1395 13.5 10.3684 13.4052 10.5372 13.2364C10.706 13.0677 10.8008 12.8387 10.8008 12.6C10.8008 12.3614 10.706 12.1324 10.5372 11.9637C10.3684 11.7949 10.1395 11.7 9.90078 11.7V9.00005C9.90078 8.76135 9.80596 8.53244 9.63718 8.36365C9.46839 8.19487 9.23948 8.10005 9.00078 8.10005H8.10078Z",
    fill: "#0ED3C0"
  })
], -1)
const _hoisted_40 = { class: "p-ml-1" }
const _hoisted_41 = {
  key: 0,
  class: "call-to-action mobile-bottom-nav"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1)

import {computed, getCurrentInstance, onMounted, ref,} from "vue";
import MultiSelect from "primevue/multiselect";
import {CandidateProfile} from "@/models/CandidateProfile";
import {CompanySize} from "@/models/CompanySize";
import {ClientSize} from "@/models/ClientSize";
import useVuelidate from "@vuelidate/core";
import {Company} from "@/models/Company";
import {createProfileService} from "@/services/profileService";
import {useI18n} from "vue-i18n";
import {
    getFinanceEmployerTypes,
    getLegalEmployerTypes,
    getTechEmployerTypes,
    prettyEmployerType
} from "@/models/employerTypes";
import {BrandId} from "@/models/BrandIds";
import {createJobTitleService} from "@/services/jobTitleService";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployerPreferences',
  props: {
    isViewing: { type: Boolean },
    candidate: {},
    availableCompanySizes: {},
    availableClientSizes: {},
    showButtons: { type: Boolean },
    disableValidation: { type: Boolean }
  },
  emits: ["next", "previous"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const app = getCurrentInstance();

const {t} = useI18n();
const availableClientSizesOptions = [...props.availableClientSizes];
availableClientSizesOptions.map(element => element.name = t(element.name));

const jobTitles = ref();
const loadJobTitles = async function () {
    let service = await createJobTitleService();
    let response = await service.getAll();
    let data = await response.data;
    if (JSON.stringify(data) !== JSON.stringify(jobTitles.value)) {
        jobTitles.value = data;
    }

  const containsRechtsanwalt = computed(() => {
    return editableCandidate.value.jobTitles?.find(e => e.id === jobTitles.value?.filter(x => x.name == t('Rechtsanwalt'))[0]?.id) != null;
  });

  const containsWirtschaftsjurist = computed(() => {
    return editableCandidate.value.jobTitles?.find(e => e.id === jobTitles.value?.filter(x => x.name == t('Wirtschaftsjurist'))[0]?.id) != null;
  });

  const containsRechtsanwaltsfachangestellte = computed(() => {
    return editableCandidate.value.jobTitles?.find(e => e.id === jobTitles.value?.filter(x => x.name == t('Rechtsanwaltsfachangestellter'))[0]?.id) != null;
  });

  const containsRechtsfachwirt = computed(() => {
    return editableCandidate.value.jobTitles?.find(e => e.id === jobTitles.value?.filter(x => x.name == t('Rechtsfachwirt'))[0]?.id) != null;
  });

  const containsPartnerassistenz = computed(() => {
    return editableCandidate.value.jobTitles?.find(e => e.id === jobTitles.value?.filter(x => x.name == t('Partnerassistenz'))[0]?.id) != null;
  });




  const isLegalCandidate = computed(() => containsRechtsanwalt.value || containsWirtschaftsjurist.value || containsRechtsanwaltsfachangestellte.value || containsRechtsfachwirt.value || containsPartnerassistenz.value);
  employerTypes.value = editableCandidate.value.brandId == BrandId.ElliotBrowne ? getTechEmployerTypes(t) : (isLegalCandidate.value ? getLegalEmployerTypes(t) : getFinanceEmployerTypes(t));

}

onMounted(() => {
    loadJobTitles();
});


const editableCandidate = ref<CandidateProfile>(props.candidate);

const employerTypes = ref();

const filteredCompanies = ref<Company[]>();
//const filteredInterestedCompanies = ref<Company[]>();

let lastSearchTerm = "";
//let lastSearchInterestedTerm = "";

const handleFilterInput = async (event) => {

    const term = event.query as string;
    lastSearchTerm = term;
    if (term.length < 2) {
        filteredCompanies.value = [];
        return;
    }

    await filterDebounced(term);
};

//const handleInterestedFilterInput = async (event) => {

//    const term = event.query as string;
//    lastSearchInterestedTerm = term;
//    if (term.length < 2) {
//        filteredCompanies.value = [];
//        return;
//    }

//    await filterInterestedDebounced(term);
//};

const debounce = (fn, delay) => {
    let timeoutID: null | number;
    return function () {
        if (timeoutID)
            clearTimeout(timeoutID);
        const args = arguments;
        timeoutID = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
};

const filterDebounced = debounce(async (term: string) => {
    const service = await createProfileService(app);

    const companies = await service.getFilteredCompanies(term);

    if (lastSearchTerm != term) {
        return;
    }

    filteredCompanies.value = companies
        ? companies.sort((a, b) => a.name.localeCompare(b.name))
        : ([] as Company[]);

    filteredCompanies.value = [{id: -1, name: term}, ...filteredCompanies.value];

}, 500);


//const filterInterestedDebounced = debounce(async (term: string) => {
//    const service = await createProfileService(app);

//    const companies = await service.getFilteredCompanies(term);

//    if (lastSearchInterestedTerm != term) {
//        return;
//    }

//    filteredInterestedCompanies.value = companies
//        ? companies.sort((a, b) => a.name.localeCompare(b.name))
//        : ([] as Company[]);

//    filteredInterestedCompanies.value = [{ id: -1, name: term }, ...filteredInterestedCompanies.value];

//}, 500);

const computedCompanies = computed({
    get: () => {
        return editableCandidate.value.excludedCompanies;

    },
    set: (value) => {
        editableCandidate.value.excludedCompanies = value;

    },
});

//const computedInterestedCompanies = computed({
//    get: () => {
//        return editableCandidate.value.preferredCompanies;
//    },
//    set: (value) => {

//        if (!value.at(-1)?.company) {
//            let company = { ...value.at(-1) }
//            const preferredCompany = ref({})
//            preferredCompany.value.name = company.name;
//            preferredCompany.value.company = company;
//            value[value.length - 1] = preferredCompany.value ;
//        }
//        if (editableCandidate.value.preferredCompanies.filter(e => e.company.id === value.at(-1)?.company.id).length > 0) {
//            return;
//        }
//        editableCandidate.value.preferredCompanies = value;
//    },
//});

const rules = {
    desiredCompanySizes: {},
    desiredClientSizes: {},
    desiredEmployerTypes: {}
};

const v$ = useVuelidate(rules, editableCandidate);

const getDisplayFriendlyEmployerType = (employerType: string) => {
    let isTech = editableCandidate.value.brandId == BrandId.ElliotBrowne;
    return prettyEmployerType(employerType, isTech, t);
};

const handleEmployerSizeRemoval = async (event, size: CompanySize) => {
    editableCandidate.value.desiredCompanySizes =
        editableCandidate.value.desiredCompanySizes.filter(
            (element) => element.id != size.id
        );
};

const handleClientSizeRemoval = async (event: any, size: ClientSize) => {
    editableCandidate.value.desiredClientSizes =
        editableCandidate.value.desiredClientSizes.filter(
            (clientSize) => clientSize.id != size.id
        );
};

const handleCompanyExclusionRemoval = async (event, company: Company) => {
    editableCandidate.value.excludedCompanies =
        editableCandidate.value.excludedCompanies.filter(
            (comp) => comp.name != company.name
        );
};
const handleEmployerTypeRemoval = async (event, employerType: string) => {
    editableCandidate.value.desiredEmployerTypes =
        editableCandidate.value.desiredEmployerTypes.filter(
            et => et != employerType
        );
};
//const handleInterestedCompanyRemoval = async (event, company: Company) => {
//    editableCandidate.value.preferredCompanies =
//        editableCandidate.value.preferredCompanies.filter(
//            (comp) => comp.name != company.name
//        );
//};

const validate = () => {
    v$.value.$touch();
    if (v$.value.$invalid) {
        document.getElementById(v$.value.$errors[0].$property)?.focus();
        document.getElementById(v$.value.$errors[0].$property)?.scrollIntoView();
        return v$.value.$error;
    }
};
const next = () => {
    if (!validate()) {
        emit("next", editableCandidate.value);
    }
};

const prev = () => {
    emit("previous", editableCandidate.value);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (_ctx.isViewing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                (editableCandidate.value.desiredCompanySizes?.length > 0)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableCandidate.value.desiredCompanySizes, (size) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: size.id
                        }, _toDisplayString(_unref(t)(size.name)), 1))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(_unref(t)("profile.multiselect.nothingselected")), 1)
                    ]))
              ]),
              _createElementVNode("label", null, _toDisplayString(_unref(t)("employer.preferences.desired.company.size")), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _createElementVNode("h5", null, _toDisplayString(_unref(t)("employer.preferences.desired.company.size.title")), 1),
              (editableCandidate.value.desiredCompanySizes?.length && editableCandidate.value.desiredCompanySizes.length>0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableCandidate.value.desiredCompanySizes, (size) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: size.id
                      }, [
                        _createTextVNode(_toDisplayString(_unref(t)(size.name)) + " ", 1),
                        _createVNode(_component_Button, {
                          icon: "pi pi-times",
                          class: "p-button-rounded p-button-outlined",
                          "data-cy": "wizard-chosen-company-size",
                          onClick: ($event: any) => (handleEmployerSizeRemoval($event, size))
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(MultiSelect), {
                modelValue: _unref(v$).desiredCompanySizes.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).desiredCompanySizes.$model) = $event)),
                display: "none",
                "data-cy": "wizard-choose-company-size",
                class: _normalizeClass({ 'p-invalid': _unref(v$).desiredCompanySizes.$error }),
                options: props.availableCompanySizes,
                filter: true,
                autoFilterFocus: true,
                filterIcon: "pi pi-search",
                filterMatchMode: _ctx.contains,
                optionLabel: "name"
              }, {
                option: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.option.name) + " " + _toDisplayString(_unref(t)("staff.members")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "class", "options", "filterMatchMode"]),
              _createElementVNode("label", null, _toDisplayString(_unref(t)("employer.preferences.desired.company.size")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).desiredCompanySizes.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("small", {
                  "data-cy": "profile-edit-company-size-error",
                  class: "p-error p-mt-0",
                  key: index
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]))
      ]),
      _createElementVNode("div", null, [
        (!_ctx.isViewing)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_10, [
              _createTextVNode(_toDisplayString(_unref(t)("employer.preferences.choose.company.type")) + " ", 1),
              _createVNode(_component_Tooltip, {
                message: _unref(t)('employer.preferences.choose.company.type.tooltip')
              }, null, 8, ["message"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)("employer.preferences.employer.type")), 1)),
        _createElementVNode("span", _hoisted_12, [
          (_ctx.isViewing && editableCandidate.value.desiredEmployerTypes?.length === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_unref(t)("profile.multiselect.nothingselected")), 1)
              ]))
            : _createCommentVNode("", true),
          (editableCandidate.value.desiredEmployerTypes?.length && editableCandidate.value.desiredEmployerTypes.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableCandidate.value.desiredEmployerTypes, (employerType) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: employerType,
                    "data-cy": "profile-edit-desiredemployertype-chosen"
                  }, [
                    _createTextVNode(_toDisplayString(getDisplayFriendlyEmployerType(employerType)) + " ", 1),
                    (!_ctx.isViewing)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          icon: "pi pi-times",
                          class: "p-button-rounded p-button-outlined",
                          "data-cy": "profile-edit-desiredemployertype-remove",
                          onClick: ($event: any) => (handleEmployerTypeRemoval($event, employerType))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isViewing)
            ? (_openBlock(), _createBlock(_unref(MultiSelect), {
                key: 2,
                options: employerTypes.value,
                display: "none",
                class: _normalizeClass({ 'p-invalid': _unref(v$).desiredEmployerTypes.$error }),
                modelValue: _unref(v$).desiredEmployerTypes.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).desiredEmployerTypes.$model) = $event)),
                optionLabel: "value",
                "data-cy": "profile-edit-desiredemployertype-list",
                optionValue: "type"
              }, null, 8, ["options", "class", "modelValue"]))
            : _createCommentVNode("", true),
          (!_ctx.isViewing)
            ? (_openBlock(), _createElementBlock("label", _hoisted_16, _toDisplayString(_unref(t)("employer.preferences.choose.employer.type")), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).desiredEmployerTypes.$errors, (error, index) => {
            return (_openBlock(), _createElementBlock("small", {
              class: "p-error p-mt-0",
              key: index
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ])
      ]),
      (editableCandidate.value.desiredEmployerTypes && editableCandidate.value.desiredEmployerTypes.includes('consulting') && editableCandidate.value.brandId === _unref(BrandId).BigFour)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("h5", null, _toDisplayString(_unref(t)("employer.preferences.choose.client.size")), 1),
            _createElementVNode("span", _hoisted_18, [
              (_ctx.isViewing)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      (editableCandidate.value?.desiredClientSizes?.length > 0)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableCandidate.value.desiredClientSizes, (size) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: size.id
                              }, _toDisplayString(_unref(t)(size.name)), 1))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                            _hoisted_23,
                            _createTextVNode(" " + _toDisplayString(_unref(t)("profile.multiselect.nothingselected")), 1)
                          ]))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (editableCandidate.value?.desiredClientSizes?.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableCandidate.value.desiredClientSizes, (size) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: size.id
                            }, [
                              _createTextVNode(_toDisplayString(_unref(t)(size.name)) + " ", 1),
                              _createVNode(_component_Button, {
                                icon: "pi pi-times",
                                class: "p-button-rounded p-button-outlined",
                                "data-cy": "wizard-chosen-client-size",
                                onClick: ($event: any) => (handleClientSizeRemoval($event, size))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(MultiSelect), {
                      modelValue: _unref(v$).desiredClientSizes.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).desiredClientSizes.$model) = $event)),
                      "data-cy": "wizard-choose-client-size",
                      display: "none",
                      class: _normalizeClass({ 'p-invalid': _unref(v$).desiredClientSizes.$invalid }),
                      options: availableClientSizesOptions,
                      filter: true,
                      autoFilterFocus: true,
                      filterIcon: "pi pi-search",
                      filterMatchMode: _ctx.contains,
                      optionLabel: "name"
                    }, null, 8, ["modelValue", "class", "filterMatchMode"]),
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("employer.preferences.choose.client.size.label")), 1)
                  ])),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).desiredClientSizes.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("small", {
                  "data-cy": "profile-edit-client-size-error",
                  class: "p-error",
                  key: index
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", null, [
        (!_ctx.isViewing)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_27, _toDisplayString(_unref(t)("employer.preferences.choose.blacklist.company")), 1))
          : _createCommentVNode("", true),
        (_ctx.isViewing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
              (computedCompanies.value && computedCompanies.value.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedCompanies.value, (company) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: company.id
                      }, _toDisplayString(company.name), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_30, [
                    _hoisted_31,
                    _createTextVNode(" " + _toDisplayString(_unref(t)("profile.multiselect.nothingselected")), 1)
                  ])),
              _createElementVNode("label", null, _toDisplayString(_unref(t)("employer.preferences.not.interested.companies")), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("span", _hoisted_33, [
                (computedCompanies.value.length && computedCompanies.value.length > 0)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_34, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedCompanies.value, (company) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: company.id
                        }, [
                          _createTextVNode(_toDisplayString(company.name) + " ", 1),
                          _createVNode(_component_Button, {
                            icon: "pi pi-times",
                            class: "p-button-rounded p-button-outlined",
                            onClick: ($event: any) => (handleCompanyExclusionRemoval($event, company))
                          }, null, 8, ["onClick"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_AutoComplete, {
                  class: "excluded-companies-autocomplete",
                  modelValue: computedCompanies.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((computedCompanies).value = $event)),
                  "data-cy": "wizard-excluded-companies",
                  multiple: true,
                  suggestions: filteredCompanies.value,
                  onComplete: handleFilterInput,
                  field: "name",
                  placeholder: _unref(t)('employer.preferences.search.companies')
                }, {
                  item: _withCtx((slotProps) => [
                    (slotProps.item.id<0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createTextVNode(_toDisplayString(_unref(t)("employer.preferences.missing.company")) + " ", 1),
                          _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(t)("employer.preferences.missing.company.create")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(slotProps.item.name), 1))
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions", "placeholder"])
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(t)("employer.preferences.company.default.exclude")), 1)
      ])
    ]),
    (_ctx.showButtons)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createVNode(_component_Button, {
            "data-cy": "button-profile-prev",
            class: "button-secondary button-back p-pl-3",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (prev()))
          }, {
            default: _withCtx(() => [
              _hoisted_42,
              _createTextVNode(_toDisplayString(_unref(t)("back")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            "data-cy": "button-profile-next",
            class: "button-secondary button-next p-pr-3",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (next()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("continue")) + " ", 1),
              _hoisted_43
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})